import AuthenticationLockIcon from "../../icons/authenticationScreen/AuthenticationLockIcon";
import AuthenticationPasswordVisibilityIcon from "../../icons/authenticationScreen/AuthenticationPasswordVisibilityIcon";

export default function AuthenticationPasswordInput({password, isPasswordVisible, setIsPasswordVisible, onPasswordChanged}) {
    // Used in AuthenticationScreen to display user identifier
    // input

    // BUILD
    return (
        <div className={"w-full flex flex-col space-y-6 justify-start items-start"}>
            <div className={"flex justify-start items-center space-x-6"}>
                <AuthenticationLockIcon />
                <label className={"text-greyLight9 font-medium text-[16px]"}
                       htmlFor="password">
                    {"Mot de passe"}
                </label>
            </div>
            <div className={"relative w-full flex items-center"}>
                <input className={"w-full h-[40px] rounded-[8px] py-6 pl-10 pr-16 text-black focus:outline-none focus:ring-2 focus:ring-primaryDark1"}
                       type={isPasswordVisible ? "text" : "password"}
                       id="password"
                       value={password ?? ""}
                       onChange={(e) => onPasswordChanged(e.target.value)}
                       required />
                <AuthenticationPasswordVisibilityIcon isPasswordVisible={isPasswordVisible}
                                                      onClick={() => setIsPasswordVisible(!isPasswordVisible)} />
            </div>
        </div>
    );
}
